import confLabels from './_HslLabels'
// import api from './api'
export default {

  JSONToCSVConvertor (JSONData, ReportTitle, ShowLabel, headings) {
    // If JSONData is not an object then JSON.parse will parse the JSON string in an Object
    var content = typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData
    var CSV = ''

    // This condition will generate the Label/Header
    if (ShowLabel) {
      let row = ''

      // This loop will loop round supplied field names in the correct order
      for (let index in headings) {
        // Now convert each value to string and comma-seprated- getting the correct language translation.
        row += this.HslGetLabel(headings[index]) + ','
      }

      row = row.slice(0, -1)

      // append Label row with line break
      CSV += row + '\r\n'
    }

    // 1st loop is to extract each row
    for (var i = 0; i < content.length; i++) {
      let row = ''

      // 2nd loop will extract each column and convert it in string comma-seprated
      for (let index in headings) {
        // console.log(indexi+" "+headings[indexi])
        row += '"' + content[i][index] + '",'
      }

      row.slice(0, row.length - 1)

      // add a line break after each row
      CSV += row + '\r\n'
    }

    if (CSV === '') {
      this.message('Invalid data')
      return
    }

    // Generate a file name
    var fileName = ReportTitle + '_'
    // this will remove the blank-spaces from the title and replace it with an underscore
    fileName += ReportTitle.replace(/ /g, '_')
    this.save(fileName + '.csv', CSV)
  },

  save (filename, data) {
    var blob = new Blob([data], {type: 'text/csv'})

    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveBlob(blob, filename)
    } else {
      var elem = window.document.createElement('a')
      elem.href = window.URL.createObjectURL(blob)
      elem.download = filename; document.body.appendChild(elem)
      elem.click(); document.body.removeChild(elem)
    }
  },

  HslGetLabel (label) {
    if (confLabels.confLabels[label] !== undefined) {
      return confLabels.confLabels[label]
    } else {
      return label
    }
  },

  message (msg, priority) {
    // priority options are success, danger, warning, info, clear
    if (priority !== 'clear') {
      // $("#alert-box").html('<div class="alert alert-'+priority+'" role="alert">'+msg+'</div>');
    } else {
      // $("#alert-box").html('');
    }
  },

  isValidDate (dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/
    return dateString.match(regEx) != null
  },

  HslGetCurTimeStamp () {
    var d = new Date()
    return this.HslFormatTimeStamp(d)
  },

  HslFormatTimeStamp (timestamp) {
    return [timestamp.getFullYear(),
      this.HslPad(timestamp.getMonth() + 1, 2),
      this.HslPad(timestamp.getDate(), 2)].join(' - ') + ' ' +
      [this.HslPad(timestamp.getHours(), 2),
        this.HslPad(timestamp.getMinutes(), 2),
        this.HslPad(timestamp.getSeconds(), 2)].join(' : ')
  },

  HslPad (n, width) {
    var z = '0'
    n = n + ''
    return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n
  }
}
